import { IfcProfileTypeEnumDeserializeStep } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesIfc from "./entity_types_ifc.gen.js";
import StepEntityBase from "../../step/step_entity_base.js";
///**
// * http://www.buildingsmart-tech.org/ifc/ifc4/final/html/link/ifcprofiledef.htm */
export class IfcProfileDef extends StepEntityBase {
    get type() {
        return EntityTypesIfc.IFCPROFILEDEF;
    }
    get ProfileType() {
        if (this.ProfileType_ === void 0) {
            this.ProfileType_ = this.extractLambda(0, IfcProfileTypeEnumDeserializeStep, false);
        }
        return this.ProfileType_;
    }
    get ProfileName() {
        if (this.ProfileName_ === void 0) {
            this.ProfileName_ = this.extractString(1, true);
        }
        return this.ProfileName_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
IfcProfileDef.query = [EntityTypesIfc.IFCPROFILEDEF, EntityTypesIfc.IFCARBITRARYCLOSEDPROFILEDEF, EntityTypesIfc.IFCARBITRARYOPENPROFILEDEF, EntityTypesIfc.IFCCOMPOSITEPROFILEDEF, EntityTypesIfc.IFCDERIVEDPROFILEDEF, EntityTypesIfc.IFCARBITRARYPROFILEDEFWITHVOIDS, EntityTypesIfc.IFCCENTERLINEPROFILEDEF, EntityTypesIfc.IFCMIRROREDPROFILEDEF, EntityTypesIfc.IFCASYMMETRICISHAPEPROFILEDEF, EntityTypesIfc.IFCCSHAPEPROFILEDEF, EntityTypesIfc.IFCCIRCLEPROFILEDEF, EntityTypesIfc.IFCELLIPSEPROFILEDEF, EntityTypesIfc.IFCISHAPEPROFILEDEF, EntityTypesIfc.IFCLSHAPEPROFILEDEF, EntityTypesIfc.IFCRECTANGLEPROFILEDEF, EntityTypesIfc.IFCTSHAPEPROFILEDEF, EntityTypesIfc.IFCTRAPEZIUMPROFILEDEF, EntityTypesIfc.IFCUSHAPEPROFILEDEF, EntityTypesIfc.IFCZSHAPEPROFILEDEF, EntityTypesIfc.IFCCIRCLEHOLLOWPROFILEDEF, EntityTypesIfc.IFCRECTANGLEHOLLOWPROFILEDEF, EntityTypesIfc.IFCROUNDEDRECTANGLEPROFILEDEF];
IfcProfileDef.expectedType = EntityTypesIfc.IFCPROFILEDEF;
